<script setup lang="ts">
import type { CmsElementZebraCmsDoubleTeaser } from "~/composables/useCustom";
import { Carousel, Slide } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css'

const props = defineProps<{
  content: CmsElementZebraCmsDoubleTeaser;
}>();

const { Rows } = props.content?.config

</script>

<template>
  <section class="mt-20 md:mt-24 lg:mt-[130px]">
    <div class="container max-w-[1070px] gap-y-10 md:gap-y-14 lg:gap-y-20 flex flex-wrap">
      <template v-for="(row, index) in Rows.value">
      <div v-if="index % 2 === 0" class="grid md:grid-cols-2 items-center gap-[40px] w-full">
        <div>
          <figure class="w-full h-[360px]">
            <NuxtImg :src="row.leftImage?.url" class="img-cover" :alt="row.leftImage?.alt" format="webp" loading="lazy" />
          </figure>
        </div>
        <div>
          <h3 class="text-2xl md:text-[28px] lg:text-[32px] mb-3 md:mb-5 lg:mb-7 foin">{{row.rowTitle}}</h3>
          <div v-html="row.rowText"></div>
          <div class="flex flex-wrap gap-5 mt-3 md:mt-8">
            <a v-if="row.buttonLeftImage && row.buttonLeftImage.title" :href="row.buttonLeftImage.url" :target="row.buttonLeftImage.target" class="btn_secondary max-w-full sm:max-w-[230px]">{{row.buttonLeftImage.title}}</a>
            <a v-if="row.buttonRightImage && row.buttonRightImage.title" :href="row.buttonRightImage.url" :target="row.buttonRightImage.target" class="btn-outline max-w-full sm:max-w-[230px]">{{row.buttonRightImage.title}}</a>
          </div>
        </div>
      </div>

      <div v-else class="grid md:grid-cols-2 items-center gap-[40px] w-full">
        <div>
          <figure class="w-full h-[360px]">
            <img src="assets/images/teaser-02.jpg" class="img-cover" alt="">
          </figure>
        </div>
        <div class="md:-order-1">
          <h3 class="text-2xl md:text-[28px] lg:text-[32px] mb-3 md:mb-5 lg:mb-7 foin">{{row.rowTitle}}</h3>
          <div v-html="row.rowText"></div>
          <div class="flex flex-wrap gap-5 mt-3 md:mt-8">
            <a v-if="row.buttonLeftImage && row.buttonLeftImage.title" :href="row.buttonLeftImage.url" :target="row.buttonLeftImage.target" class="btn_secondary max-w-full sm:max-w-[230px]">{{row.buttonLeftImage.title}}</a>
            <a v-if="row.buttonRightImage && row.buttonRightImage.title" :href="row.buttonRightImage.url" :target="row.buttonRightImage.target" class="btn-outline max-w-full sm:max-w-[230px]">{{row.buttonRightImage.title}}</a>
          </div>
        </div>
      </div>
      </template>
    </div>
  </section>
</template>
